import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Spinner from "../components/Spinner";
import Footer from "../components/Footer";
import logo from "../assets/companyLogo.png";
import scoreLogo from "../assets/scoreLogo.png";
import tryAgain from "../assets/tryAgain.png";
import { LanguageContext } from "../contexts/LanguageContext";

const Score = () => {
  const [scoreData, setScoreData] = useState(null);
  const [summary, setSummary] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { state } = useContext(LanguageContext);
  const navigate = useNavigate();
  const loaction = useLocation();
  const { id, tempCode } = useParams();

  useEffect(() => {
    getScore();
  }, []);
  useEffect(() => {
    window.history.pushState(null, "", window.location.href);

    const handleBackButton = () => {
      navigate("/user-registration", { replace: true });
    };

    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, []);
  const getScore = async () => {
    const API_URL = process.env.REACT_APP_API_URL + "/get_score";
    const config = {
      headers: { "ngrok-skip-browser-warning": "true" },
      params: { attempt_id: id },
    };
    try {
      setIsLoading(true);
      const response = await axios.get(API_URL, config);
      setScoreData(response.data.payload[0]);
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Spinner />
      </div>
    );
  }
  const userData = JSON.parse(localStorage.getItem("user"));

  const totalReward = scoreData?.total_reward ?? 0;
  const totalQuestions = scoreData?.total_questions ?? 10;
  const correctAnswers = scoreData?.correct_answers ?? 0;
  const userName = userData?.name ?? "Tejas";
  const percent = Math.round((correctAnswers / totalQuestions) * 100);
  const isPassed = percent >= 70;
  return (
    <div style={s.page}>
      <div style={s.header}>
        <img src={logo} alt="GoApptiv" style={s.logo} />
      </div>

      <div style={s.body}>
        <div style={s.illustrationWrap}>
          {isPassed ? (
            <img
              src={scoreLogo}
              alt="Score illustration"
              style={s.scoreLogoImg}
            />
          ) : (
            <img
              src={tryAgain}
              alt="Score illustration"
              style={s.scoreLogoImg}
            />
          )}
        </div>

        <div style={s.textSide}>
          {isPassed ? (
            <p style={s.congratsLine}>
              Congratulations <span style={s.nameHighlight}>{userName}!</span>
            </p>
          ) : (
            <p style={s.congratsLine}>
              Thank you <span style={s.nameHighlight}>{userName}!</span>
            </p>
          )}

          <p style={s.scoreLine}>You have scored</p>
          <p style={s.scoreBig}>
            <span style={s.percentHighlight}>{percent}%</span>
            <span style={s.inQuiz}> in Quiz</span>
          </p>

          <p style={s.subText}>
            You answered {correctAnswers}/{totalQuestions} question right.
            <br />
          </p>

          <p style={s.subText}>
            <b>Please Contact HR Team</b>
          </p>

          <div style={s.btnGroup}>
            <button style={s.downloadBtn} onClick={() => window.print()}>
              Download &nbsp;
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
                style={{ verticalAlign: "middle" }}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                />
              </svg>
            </button>

            <button
              style={s.homeBtn}
              onClick={() => navigate("/user-registration", { replace: true })}
            >
              Go To Home &nbsp;→
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const s = {
  page: {
    minHeight: "100vh",
    backgroundColor: "#fff",
    fontFamily: "'Segoe UI', sans-serif",
    display: "flex",
    flexDirection: "column",
    overflowX: "hidden",
  },

  header: {
    padding: "clamp(12px, 2vw, 20px) clamp(16px, 4vw, 40px)",
    borderBottom: "1px solid #f0f0f0",
    display: "flex",
    alignItems: "center",
  },

  logo: {
    height: "clamp(28px, 4vw, 40px)",
    width: "auto",
    objectFit: "contain",
  },

  body: {
    flex: 1,

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    gap: "clamp(24px, 5vw, 60px)",

    padding: "clamp(20px, 5vw, 60px)",

    flexWrap: "wrap",

    width: "100%",
    boxSizing: "border-box",
  },

  illustrationWrap: {
    flex: "1 1 500px",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    minWidth: "280px",
  },

  scoreLogoImg: {
    width: "100%",
    maxWidth: "722px",
    height: "auto",
    maxHeight: "70vh",
    objectFit: "contain",
  },

  textSide: {
    flex: "1 1 380px",

    maxWidth: "500px",
    minWidth: "280px",

    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    boxSizing: "border-box",
  },

  congratsLine: {
    fontSize: "clamp(18px, 2.5vw, 22px)",
    color: "#1a1a1a",
    fontWeight: 500,
    margin: 0,
    lineHeight: 1.4,
  },

  nameHighlight: {
    color: "#F5A623",
    fontWeight: 700,
  },

  scoreLine: {
    fontSize: "clamp(14px, 2vw, 16px)",
    color: "#333",
    margin: "14px 0 0",
  },

  scoreBig: {
    margin: "6px 0 18px",
    lineHeight: 1.2,

    display: "flex",
    alignItems: "baseline",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "8px",
  },

  percentHighlight: {
    fontSize: "clamp(42px, 8vw, 72px)",
    fontWeight: 800,
    color: "#F5A623",
  },

  inQuiz: {
    fontSize: "clamp(22px, 4vw, 34px)",
    fontWeight: 700,
    color: "#1a1a1a",
  },

  subText: {
    fontSize: "clamp(13px, 2vw, 15px)",
    fontStyle: "italic",
    color: "#555",
    lineHeight: 1.7,
    margin: "0 0 28px",
  },

  btnGroup: {
    display: "flex",
    flexDirection: "column",
    alignSelf: "center",
    gap: 14,
    width: "100%",
    maxWidth: 280,
  },

  downloadBtn: {
    width: "100%",

    padding: "14px 20px",

    borderRadius: 10,
    border: "1.5px solid #ccc",

    backgroundColor: "#fff",
    color: "#333",

    fontSize: "clamp(13px, 2vw, 15px)",
    fontWeight: 500,

    cursor: "pointer",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,

    transition: "0.2s ease",
  },

  homeBtn: {
    width: "100%",

    padding: "14px 20px",

    borderRadius: 10,
    border: "none",

    backgroundColor: "#F5A623",
    color: "#fff",

    fontSize: "clamp(13px, 2vw, 15px)",
    fontWeight: 600,

    cursor: "pointer",

    transition: "0.2s ease",
  },
};

export default Score;
